import React, { useEffect, useState } from "react";

import { Table } from "clearsense-ui/components";

import Filters from "./Filters";

import { survivorshipDomainRecordDetailsTableColumns } from "../../../utils";
import ExpandAllCollapseAll from "../RecordDetails/ExpandAllCollapseAll";
import TabHeader from "../RecordDetails/TabHeader";
import { formatDataForSurvivorshipDomainDetailsTable } from "../utils";

const SurvivorshipDomainDetails = ({
  recordDetails,
  searchIdentifier,
  tableData,
  cdeFilters,
  cdes,
  businessRules,
  setTableData,
  setCdeFilters,
}) => {
  const [expandedAccordions, setExpandedAccordions] = useState([0]);

  const applyFilters = () => {
    const formattedData = formatDataForSurvivorshipDomainDetailsTable(
      recordDetails,
      cdeFilters,
      Object.keys(recordDetails?.result?.[0])
    );
    setTableData(formattedData);
  };

  useEffect(() => {
    searchIdentifier.context_value && applyFilters();
  }, [cdeFilters]);

  const generateAllHierarchyKeys = tableData =>
    tableData.reduce(
      (acc, item) =>
        item?.children
          ? [...acc, item.key, ...generateAllHierarchyKeys(item.children)]
          : [...acc, item.key],
      []
    );

  return (
    <div className="space-y-8">
      {!!Object.keys(recordDetails)?.length && (
        <div className="border bg-white p-8">
          <div className="w-full space-y-6">
            <TabHeader
              recordDetails={recordDetails}
              searchIdentifier={searchIdentifier}
            />
            <Filters
              cdes={cdes}
              cdeFilters={cdeFilters}
              setCdeFilters={setCdeFilters}
            />
            <div className="flex justify-end items-center">
              <ExpandAllCollapseAll
                onExpand={() =>
                  setExpandedAccordions([
                    ...generateAllHierarchyKeys(tableData),
                  ])
                }
                onCollapse={() => setExpandedAccordions([])}
              />
            </div>
          </div>

          <div className="border">
            <Table
              rowSelection={false}
              allowRowClick
              columnData={survivorshipDomainRecordDetailsTableColumns(
                Object.keys(recordDetails?.result?.[0]),
                businessRules
              )}
              rowData={tableData}
              expandable={{
                expandRowByClick: true,
                defaultExpandedRowKeys: [0],
                expandedRowKeys: [...expandedAccordions],
                onExpand: (isExpand, row) =>
                  setExpandedAccordions(prev =>
                    isExpand
                      ? [...prev, row.key]
                      : prev.filter(item => item !== row.key)
                  ),
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SurvivorshipDomainDetails;
